<!-- src/components/NavBar.vue -->
<template>
  <div class="navbar_styling fontist">
    <b-navbar
      toggleable="xl"
      type="light"
      class="navbar_style align-items-center"
    >
      <b-navbar-brand @click="home" class="logo d-flex align-items-center">
        <img class="logo_img" src="@/assets/EngramLogo.png" />
        <span class="logo_btn ms-3">Engram</span>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" type="light"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="navbar_tab_section align-items-center w-100">
          <b-nav-item-dropdown right class="nav-dropdown" no-caret>
            <template #button-content>
              <span class="dd-link">
                APWH Units
                <img
                  :src="require('@/assets/writing_feature/chevron-down.svg')"
                  alt="Icon"
                />
              </span>
            </template>
            <b-dropdown-item @click="next('All_Periods')" class="drop-item"
              >All Units</b-dropdown-item
            >
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              v-for="unit in allUnits"
              :key="`${unit.timePeriod}-${unit.id}`"
              @click="goToUnit(unit)"
              class="drop-item"
            >
              {{ unit.id }}: {{ unit.title }}
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <!--
          <b-nav-item @click="next('Quiz')">
            <span class="nav-dropdown">Quiz Questions</span>
          </b-nav-item>
          -->

          <b-nav-item-dropdown right class="nav-dropdown" no-caret>
            <template #button-content>
              <span class="dd-link">
                Essay Writing
                <img
                  :src="require('@/assets/writing_feature/chevron-down.svg')"
                  alt="Icon"
                />
              </span>
            </template>
            <b-dropdown-item @click="next('001')" class="drop-item"
              >LEQ Workshop</b-dropdown-item
            >
            <b-dropdown-item @click="next('001')" class="drop-item" disabled
              >DBQ Workshop</b-dropdown-item
            >
            <b-dropdown-item @click="next('001')" class="drop-item" disabled
              >SAQ Workshop</b-dropdown-item
            >
          </b-nav-item-dropdown>

          <!--
          <b-nav-item @click="goToCramPacks">
            <span class="nav-dropdown">Cram Packs</span>
          </b-nav-item>
          -->

          <!-- SEARCH -->
          <b-nav-form class="navbar-search mb-0 mt-0 position-relative me-sm-0 me-md-3 me-lg-4">
            <search-bar />
          </b-nav-form>

          <b-nav-form class="navbar-auth">
            <template v-if="isAuthenticated">
              <b-button
                id="purples"
                class="border-0 navbar-purple"
                @click="goToAccount"
              >
                My Account
              </b-button>
              <b-button
                id="purples"
                class="border-0 navbar-purple ms-3"
                :disabled="authLoading"
                @click="handleLogOut"
              >
                {{ authLoading ? "Logging out..." : "Logout" }}
              </b-button>
            </template>
            <template v-else>
              <b-button
                id="purples"
                class="border-0 navbar-purple"
                @click="goToLogin"
              >
                Login
              </b-button>
              <b-button
                id="purples"
                class="border-0 navbar-purple ms-3"
                @click="goToSignup"
              >
                Sign up
              </b-button>
            </template>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { computed } from "vue";
import {
  goToHome,
  goToPeriod,
  pushRoute,
  goToCramPacks
} from "@/router/navigation";
import store from "@/store";
import { logOutUser, useAuthState } from "@/services/authService";
import SearchBar from "@/components/SearchBar.vue";

export default {
  name: "NavBar",
  components: {
    SearchBar
  },
  setup() {
    // --- nav actions ---
    const home = () => {
      store.dispatch("setTopicCategory", 0);
      // keep store update, then navigate via centralized helper
      goToHome();
    };

    const next = name => pushRoute(name);
    const { isAuthenticated, loading } = useAuthState();

    const authLoading = computed(() => loading.value);

    const goToLogin = () => pushRoute("Login");
    const goToSignup = () => pushRoute("Signup");
    const goToAccount = () => pushRoute("Account");

    const handleLogOut = async () => {
      try {
        await logOutUser();
        pushRoute("Home");
      } catch (error) {
        console.error("Logout failed", error);
      }
    };

    const timePeriod = (timePeriod, timePeriodTitle) => {
      store.dispatch("setTimePeriod", timePeriod);
      goToPeriod(timePeriodTitle, timePeriod);
    };

    // Extract all units from all time periods
    const allUnits = computed(() => {
      const units = [];
      const timePeriods = store.state.timePeriodHeaders || [];
      timePeriods.forEach(period => {
        const unitHeaders = Object.keys(period.unitTitles || {});
        unitHeaders.forEach((unitHeader, index) => {
          const unitIdMatch = unitHeader.match(/^Unit\s*\d+/i);
          units.push({
            id: unitIdMatch ? unitIdMatch[0] : `Unit ${index + 1}`,
            title: unitHeader.replace(/^Unit\s*\d+:\s*/, ""),
            unitHeader,
            timePeriod: period.timePeriod,
            periodHeader: period.header
          });
        });
      });
      return units;
    });

    // Navigate to a specific unit
    const goToUnit = unit => {
      store.dispatch("setTimePeriod", unit.timePeriod);
      goToPeriod(unit.periodHeader, unit.timePeriod, {
        unit: unit.id
      });
    };

    return {
      // nav
      home,
      timePeriod,
      next,
      goToCramPacks,
      goToUnit,
      allUnits,
      isAuthenticated,
      authLoading,
      goToLogin,
      goToSignup,
      goToAccount,
      handleLogOut
    };
  }
};
</script>

<style scoped lang="sass" src="@/assets/css/essayWriting.sass"></style>
<style scoped lang="sass" src="@/assets/css/navbar.sass"></style>
